import ProductCard from '@repo/ui/src/components/Cards/ProductCard';
import type { MeaterProduct } from '@src/domain/types/MeaterProduct';

interface MeaterGridItemProps {
  item: MeaterProduct;
}

const MeaterGridItem = ({ item }: MeaterGridItemProps) => {
  const prices = item.variants.map((v) => v.price);
  const minPrice = prices.length > 0 ? Math.min(...prices) : item.price;
  const maxPrice = prices.length > 0 ? Math.max(...prices) : item.price;

  const product = {
    ...item,
    price: minPrice,
    maxPrice: maxPrice > minPrice ? maxPrice : undefined,
  };

  return (
    <ProductCard
      product={product}
      image={item.previewImage}
    />
  );
};

export default MeaterGridItem;
